import { render, staticRenderFns } from "./HandbookSectionList.vue?vue&type=template&id=09611167&"
import script from "./HandbookSectionList.vue?vue&type=script&lang=js&"
export * from "./HandbookSectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports